<template>
  <div>
    <div @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="关联详情"
      :visible.sync="dialogTableVisible"
      append-to-body
      width="650px"
      destroy-on-close
      @open="openDialog"
      :reverse="true"
    >
      <!-- 通过 dialogTableVisible 重新渲染 dom，避免 handleClickEdit 获取不到 dom -->
      <div v-if="dialogTableVisible">
        <div
          class="detail-item"
          v-for="(item, index) in detailInfo"
          :key="item.relation_log_id"
        >
          <div class="business-time flex">
            <span v-if="showDatePickerIndex !== index">
              {{ item.relation_time }}
            </span>
            <el-form v-if="showDatePickerIndex === index">
              <el-form-item>
                <el-date-picker
                  class="date-picker"
                  v-model="item.relation_time"
                  type="datetime"
                  placeholder="选择日期"
                  ref="datePickerRef"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  @change="handleDateChange(item.relation_time)"
                  :picker-options="effectiveDate"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/teacher/edit.png"
              width="18px"
              height="18px"
              style="margin-left: 10px; cursor: pointer"
              v-if="item.allow_modify_business_time && !from"
              @click="handleClickEdit(item, index)"
            />
          </div>
          <div class="detail-content">
            <div class="detail-top">
              <div class="content-top flex">
                <div class="left flex">
                  <div class="type font-size-13 mwow-green">
                    {{ handleType(item.type) }}
                  </div>
                  <div class="border"></div>
                  <div class="create-time font-size-13">
                    生成记录时间：{{ item.create_time }}
                  </div>
                </div>
                <div class="right" v-if="item.is_revoke === 1">已撤销</div>
              </div>
              <div class="content-info font-size-13" v-show="item.type === 1">
                手动将学员“{{ originData.student }}”与“{{
                  item.teacher.name
                }}”完成关联；
              </div>
              <div class="content-info font-size-13" v-show="item.type === 2">
                手动将学员“{{ originData.student }}”与“{{
                  item.teacher.name
                }}”解除关联；
              </div>
              <div class="content-info font-size-13" v-show="item.type === 3">
                <p>学员已结课，解除关联；</p>
                <p style="margin-top: 7px">备注：{{ item.remark }}</p>
              </div>
              <div class="content-info font-size-13" v-show="item.type === 4">
                <p>学员已结业，解除关联；</p>
                <p style="margin-top: 7px">备注：{{ item.remark }}</p>
              </div>
              <div class="content-info font-size-13" v-show="item.type === 5">
                <p>
                  {{
                    `学员完成教师 “${item.teacher.name}” 课次点名，非班级学员为 “已流失” 状态；`
                  }}
                </p>
                <p style="margin-top: 7px">备注：{{ item.remark }}</p>
              </div>
              <div class="content-info font-size-13" v-show="item.type === 7">
                <p>
                  {{
                    `手动将学员“${originData.student}”与“${item.teacher.name}”解除关联，不影响流失数据！`
                  }}
                </p>
                <p style="margin-top: 7px">备注：{{ item.remark }}</p>
              </div>
              <div class="font-size-13" style="margin-top: 24px">
                生成记录人员：{{ item.staff.name }}
              </div>
            </div>

            <div
              class="operate-btn btn"
              @click="handleRevokeLog(item)"
              v-if="item.allow_revoke && !from"
            >
              撤销操作记录
            </div>

            <div
              class="operate-wrap"
              v-if="item.log_list && item.log_list.length > 0"
            >
              <div
                class="operate-item"
                v-for="(it, ind) in item.log_list"
                :key="ind"
              >
                <div class="operate-info font-size-13 flex">
                  <div class="font-size-13">
                    操作类型：{{ handleType(it.type) }}
                  </div>
                  <div class="border"></div>
                  <div class="font-size-13">
                    操作时间：{{ getTime(new Date(it.create_time * 1000)) }}
                  </div>
                  <div class="border"></div>
                  <div class="font-size-13">操作人员：{{ it.staff.name }}</div>
                </div>
                <div class="remark-reason flex">
                  <div class="reason-label font-size-13">备注原因：</div>
                  <div class="reason-value font-size-13">
                    {{ it.remark }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-empty
          :image-size="32"
          v-if="detailInfo.length == 0"
          description="暂未有关联详情记录"
          image="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/nodata.png"
        ></el-empty>
      </div>
    </el-dialog>

    <el-dialog
      title="备注原因"
      :visible.sync="remarkDialogVisible"
      append-to-body
      width="500px"
      @close="handleCloseRemark('auto')"
    >
      <el-input
        type="textarea"
        v-model="remarkInfo.remark"
        placeholder="请填写原因（必填），最多可输入100字"
        maxlength="100"
      ></el-input>
      <div class="flex remark-btns">
        <el-button type="success" size="mini" @click="handleSubmit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  relationStudentDetailApi,
  studentCourseLogListApi,
  relationLogRevokeApi,
  relationLogTimeModifyApi,
} from "@/api/teacherManage";
import { dateFormat } from "@/utils/timeFormat";

export default {
  props: ["rid", "studentId", "courseId", "originData", "from"],
  data() {
    return {
      dialogTableVisible: false,
      remarkDialogVisible: false,
      num: 3,
      detailInfo: [],
      remarkInfo: {
        createTime: "",
        index: "",
        remark: "",
        interface_type: "time",
      },
      showDatePickerIndex: -1, // 只显示对应 detail-item 的 date-picker 组件
      effectiveDate: {
        disabledDate: (date) => {
          return date > new Date();
        },
      },
    };
  },
  methods: {
    showDialog() {
      this.showDatePickerIndex = -1;
      this.dialogTableVisible = true;
    },
    openDialog() {
      // 初始化
      this.remarkInfo = {
        createTime: "",
        index: "",
        remark: "",
        interface_type: "time",
      };
      if (this.rid) {
        relationStudentDetailApi({
          relation_id: this.rid,
        }).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((item) => {
              item.create_time = this.getTime(
                new Date(Number(item.create_time + "000"))
              );
              item.relation_time = this.getTime(
                new Date(Number(item.relation_time + "000"))
              );
              // 判断更改的业务时间是否为同一天
              item.relation_time_bak = item.relation_time;
            });
            this.detailInfo = res.data.list;
          }
        });
      } else if (this.studentId && this.courseId) {
        studentCourseLogListApi({
          student_id: this.studentId,
          course_id: this.courseId,
        }).then((res) => {
          res.data.list.map((item) => {
            item.create_time = this.getTime(
              new Date(Number(item.create_time + "000"))
            );
            item.relation_time = this.getTime(
              new Date(Number(item.relation_time + "000"))
            );
            item.relation_time_bak = item.relation_time;
          });
          this.detailInfo = res.data.list;
        });
      }
    },
    getTime(e) {
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format;
    },
    handleDateChange(relation_time) {
      this.remarkInfo.type = "time";
      // 传参补零
      this.remarkInfo.business_time = relation_time + ":00";
      let date = dateFormat(
        "YYYY-mm-dd",
        new Date(this.remarkInfo.business_time).getTime()
      );
      let dateBak = dateFormat(
        "YYYY-mm-dd",
        new Date(
          this.detailInfo[this.showDatePickerIndex].relation_time_bak
        ).getTime()
      );
      if (date === dateBak) {
        this.detailInfo[this.showDatePickerIndex].relation_time =
          this.detailInfo[this.showDatePickerIndex].relation_time_bak;
        this.$message({
          type: "warning",
          message: "同一天业务时间，不需变更",
        });
        this.handleCloseRemark();
        return false;
      }
      this.remarkDialogVisible = true;
    },
    handleSubmit() {
      if (this.remarkInfo.interface_type === "time") {
        relationLogTimeModifyApi({
          relation_log_id: this.remarkInfo.relation_log_id,
          remark: this.remarkInfo.remark,
          business_time: this.remarkInfo.business_time,
        })
          .then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.handleCloseRemark();
            }
          })
          .catch(() => {
            this.handleCloseRemark();
          });
      }
      if (this.remarkInfo.interface_type === "relation") {
        relationLogRevokeApi({
          relation_log_id: this.remarkInfo.relation_log_id,
          remark: this.remarkInfo.remark,
        }).then((res) => {
          if (res.error_code === 0) {
            if (this.remarkInfo.type === 1) {
              this.$message({
                type: "success",
                message: "撤销成功，已撤销关联",
              });
            } else if (this.remarkInfo.type === 2) {
              this.$message({
                type: "success",
                message: "撤销成功，已恢复关联",
              });
            } else {
              this.$message({
                type: "success",
                message: "撤销成功",
              });
            }
            this.handleCloseRemark();
            this.$emit("change"); // 通知父组件更新列表
          }
        });
      }
    },
    handleCloseRemark(val) {
      this.remarkDialogVisible = false;
      this.showDatePickerIndex = -1;
      // 控制接口调用次数
      if (val) {
        this.openDialog();
      }
    },
    handleRevokeLog(item) {
      this.remarkInfo.relation_log_id = item.relation_log_id;
      this.remarkInfo.interface_type = "relation";
      this.remarkInfo.type = item.type;
      if (item.type === 1) {
        this.$confirm(
          `"确认把学员${this.originData.student}的${this.originData.course}课程老师${item.teacher.name}关联操作记录撤销?撤销后，该学员成为课程老师的流失学员，会影响课程老师的流失率，请谨慎操作"`,
          "撤销关联",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
          }
        )
          .then(() => {
            this.remarkDialogVisible = true;
          })
          .catch(() => {});
      }
      if (item.type === 2) {
        this.$confirm(
          `"确认把学员${this.originData.student}的${this.originData.course}课程老师${item.teacher.name}解除关联操作记录撤销?撤销后，该老师恢复为学员的课程老师"`,
          "恢复关联",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
          }
        )
          .then(() => {
            this.remarkDialogVisible = true;
          })
          .catch(() => {});
      }
      if (item.type === 7) {
        this.$confirm(
          `"确认把学员${this.originData.student}的${this.originData.course}课程老师${item.teacher.name}调班操作记录撤销?"`,
          "恢复关联",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
          }
        )
          .then(() => {
            this.remarkDialogVisible = true;
          })
          .catch(() => {});
      }
    },
    // 编辑业务时间，对应的时间控件自动聚焦
    handleClickEdit(item, index) {
      this.showDatePickerIndex = index;
      setTimeout(() => {
        let detailItem = document.querySelectorAll(".detail-item");
        let datePicker = detailItem[index].querySelector(".date-picker");
        let elInput = datePicker.querySelector(".el-input__inner");
        elInput.focus();
      }, 100);
      this.remarkInfo.relation_log_id = item.relation_log_id;
    },
    handleType(type) {
      let text = "";
      if (type === 1) {
        text = "手动关联";
      } else if (type === 2) {
        text = "手动解除";
      } else if (type === 3) {
        text = "学员结课";
      } else if (type === 4) {
        text = "学员结业";
      } else if (type === 5) {
        text = "撤销操作记录";
      } else if (type === 6) {
        text = "修改业务时间";
      } else if (type === 7) {
        text = "调班";
      }
      return text;
    },
  },
};
</script>
<style scoped lang="scss">
.detail-item {
  padding: 0 20px;
  margin-bottom: 20px;
  /deep/.business-time {
    color: rgba(98, 99, 100, 1);
    font-weight: 700;
    margin-bottom: 10px;
    font-size: 14px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .detail-content {
    border: 1px solid rgba(231, 232, 234, 1);
    border-radius: 10px;
    .detail-top {
      padding: 15px 20px;
      .content-top {
        .left {
          flex: 1;
          .type {
            padding: 5px 13px;
            border-radius: 4px;
            background: #f0fdfa;
          }

          .create-time {
            color: rgba(162, 165, 168, 1);
          }
          .bg-gray {
            background: rgba(239, 241, 242, 1);
          }
        }
        .right {
          color: rgba(245, 110, 110, 1);
        }
      }
      .content-info {
        color: rgba(92, 93, 94, 1);
        margin: 11px 0;
        font-size: 13px;
        p {
          font-size: 13px;
        }
      }
    }

    .btn {
      padding: 5px 15px;
      border-radius: 4px;
      cursor: pointer;
      display: inline-block;
    }
    .operate-btn {
      border: 1px solid #45b13b;
      color: #45b13b;
      margin-bottom: 10px;
      margin-left: 20px;
    }

    .operate-wrap {
      background: rgba(239, 241, 242, 0.5);
      padding-top: 17px;
      .operate-item {
        padding: 0px 20px 17px 20px;
        .operate-info {
          margin-bottom: 10px;
          color: rgba(162, 165, 168, 1);
        }
        .remark-reason {
          color: rgba(162, 165, 168, 1);
          align-items: flex-start;
          .reason-value {
            flex: 1;
          }
        }
      }
    }
  }
}

.remark-btns {
  justify-content: center !important;
  padding-top: 10px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.border {
  height: 13px;
  border: 1px solid rgba(231, 232, 234, 1);
  margin: 0 18px;
}
.font-size-13 {
  font-size: 13px;
}
</style>
